<div class="bg-0 border-30 border rounded text-sm mt-1 shadow" [ngStyle]="{ 'width': data.width }">
  <div class="py-2">
    <ng-container *ngTemplateOutlet="data.template"></ng-container>
  </div>
</div>